import axios from "axios";
import { getToken, getTokenMicro } from "../../config/getToken";
import { env } from "../../env";

const authAxios = axios.create();

authAxios.interceptors.response.use(
  (response) => {
    return response;
  },

  (error) => {
    return Promise.reject(error);
  },
);

/** Inicia sesión en el sistema.
 * @param {Object} data - Credenciales de inicio de sesión.
 * @returns {Promise<*>} Respuesta del servidor. */
export function LoginService(data) {
  return authAxios({
    method: "POST",
    url: "auths/login",
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data: {
      email: data.email,
      password: data.password,
    },
  });
}

/** Verifica la sesión del usuario.
 * @param {Object} data - Datos de verificación.
 * @returns {Promise<*>} Estado de la sesión. */
export function CheckSession(data) {
  return authAxios({
    method: "POST",
    url: "auths/check/sessions",
    baseURL: env.REACT_APP_API_URL,
    data: data,
  });
}

/** Renueva el token de autenticación.
 * @param {Object} data - Datos con email y refreshToken.
 * @returns {Promise<*>} Nuevo token. */
export function refreshToken(data) {
  return authAxios({
    method: "POST",
    url: "auths/refresh/tokens",
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data: {
      email: data.email,
      refreshToken: data.refreshToken,
    },
  });
}
/** Cierra la sesión del usuario.
 * @returns {Promise<*>} Respuesta del servidor. */
export async function LogoutService() {
  const token = await getToken();
  return authAxios({
    method: "POST",
    url: "auths/logout",
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,

    headers: {
      Authorization: token,
    },
  });
}

/** Envía solicitud de recuperación de contraseña.
 * @param {Object} data - Datos con el email del usuario.
 * @returns {Promise<*>} Respuesta del servidor. */
export function RecoverPasswordService(data) {
  return authAxios({
    method: "POST",
    url: "auths/forgot/passwords",
    baseURL: env.REACT_APP_API_URL,
    data: {
      email: data.email,
    },
  });
}

/** Valida las credenciales y cambia la contraseña.
 * @param {Object} data - Datos con email y nueva contraseña.
 * @returns {Promise<*>} Respuesta del servidor. */
export async function validateCredentialsService(data) {
  const token = await getToken();

  return authAxios({
    method: "POST",
    url: "auths/changes/passwords",
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    data: {
      email: data.email,
      oldPassword: "C4@jk3zmhn9j",
      newPassword: data.password,
    },
    headers: {
      Authorization: token,
    },
  });
}

/** Cambia la contraseña del usuario.
 * @param {Object} data - Datos con email, oldPassword y newPassword.
 * @returns {Promise<*>} Respuesta del servidor. */
export async function changePasswordService(data) {
  const token = await getToken();

  return authAxios({
    method: "POST",
    url: "auths/changes/passwords",
    baseURL: env.REACT_APP_API_URL,
    data: {
      email: data.email,
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
    },
    headers: {
      Authorization: token,
    },
  });
}

/** Recupera la contraseña del usuario.
 * @param {Object} data - Datos de recuperación.
 * @returns {Promise<*>} Respuesta del servidor. */
export async function recoveryPassword(data) {
  const token = await getToken();

  return authAxios({
    method: "POST",
    url: "auths/passwords/recoveries",
    baseURL: env.REACT_APP_API_URL,
    data: { ...data },
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene el token de Qlik Sense.
 * @param {Object} data - Datos de autenticación.
 * @returns {Promise<*>} Token de Qlik Sense. */
export async function TokenQlikSense(data) {
  const token = await getTokenMicro();

  return authAxios({
    method: "POST",
    url: "qlik/operations",
    baseURL: env.REACT_APP_API_URL_QLICK,
    data: data,
    headers: {
      Authorization: token,
    },
  });
}

/** Registra el cierre de sesión de usuario de soporte.
 * @param {Object} data - Payload con eanCompany, nameCompany, country, email.
 * @returns {Promise<*>} Respuesta del servidor. */
export async function SupportLogoutService(data) {
  const token = await getTokenMicro();
  return axios({
    method: "POST",
    url: "users/restore/supports/companies",
    baseURL: env.REACT_APP_API_URL_USERS,
    validateStatus: null,
    data: data,
    headers: {
      Authorization: token,
    },
  });
}

/** Desbloquea un usuario en Cognito.
 * @param {Object} data - Datos del usuario a desbloquear.
 * @returns {Promise<*>} Respuesta del servidor. */
export async function UnlockUserCognito(data) {
  const token = await getToken();

  return authAxios({
    method: "POST",
    url: "auths/unlock/users/cognito",
    baseURL: env.REACT_APP_API_URL,
    data: data,
    headers: {
      Authorization: token,
    },
  });
}
